/* eslint-disable import/prefer-default-export */
import { useMutation } from '@tanstack/react-query';

import { layer1Axios } from '../../../api/http';

const postGeneratedText = async ({ data, jobId }) =>
  layer1Axios({
    method: 'POST',
    url: `/v3/main/jobs/${jobId}/generate-text-sections`,
    data,
  }).then((res) => res.data);

export const useGenerateTextMutation = ({
  jobId,
  onSuccess,
  onError,
  options = {},
}) =>
  useMutation({
    mutationFn: (data) => postGeneratedText({ data, jobId }),
    onSuccess,
    onError,
    ...options,
  });
